import { NgModule } from '@angular/core';
import { GlobalVariablesModule } from './global-variables/global-variables.module';
import { CoreModule } from '../core/core.module';

@NgModule({
  imports: [
    GlobalVariablesModule,
    CoreModule,
],
  declarations: [

  ],
  exports:[GlobalVariablesModule],
})
export class FeatureModule { }
